import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.541 11.913c-.008-1.46.654-2.561 1.993-3.372-.75-1.07-1.881-1.659-3.376-1.774-1.414-.111-2.96.823-3.526.823-.598 0-1.97-.783-3.045-.783C6.363 6.843 4 8.577 4 12.104c0 1.042.191 2.118.574 3.229.51 1.46 2.351 5.038 4.272 4.979 1.004-.024 1.713-.712 3.02-.712 1.268 0 1.925.712 3.045.712 1.937-.028 3.603-3.281 4.089-4.745-2.598-1.22-2.459-3.579-2.459-3.654Zm-2.255-6.53c1.088-1.288.988-2.461.956-2.883-.96.056-2.072.652-2.706 1.388-.697.787-1.108 1.762-1.02 2.86 1.04.079 1.989-.454 2.77-1.365Z",
      fill: "#616a75"
    }, null, -1)
  ])))
}
export default { render };